(ns kyber.constants
  (:require [applied-science.js-interop :as j]
            [common.transit :as t]
            [clojure.string :refer [split]]))
;; goog-define is used instead of def, else there are warnings for a
;; def being redefined — https://cljs.github.io/api/cljs.core/goog-define

(defn- kpc-config [suffix]
  (j/get js/window (str "KPC_" suffix)))

;; Pulled down from partner-config.js
(def partner-color
  (kpc-config "PARTNER_COLOR"))
(def partner-logo
  (kpc-config "PARTNER_LOGO"))
(def partner-name ;; used in error reporting
  (kpc-config "PARTNER_NAME"))

;; App Environment
(def app-env
  (kpc-config "APP_ENV"))

(goog-define app-version "")

;; Serialized (transit) feature-flag config
(goog-define serialized-feature-flags-config "")

;; App name: `learner` or `admin`
;; Use atom as app is not known until module loaded
;; by shadow-cljs's loader
(def app-name (atom nil))

;; Will display first-name & last-name
(def self-reg-require-name
  (kpc-config "SELF_REG_REQUIRE_NAME"))

;; Bugsnag API Key
(def bugsnag-api-key
  (kpc-config "BUGSNAG_API_KEY"))

;; LogRocket App ID
(def logrocket-app-id
  (kpc-config "LOGROCKET_APP_ID"))

;; Host api url
(goog-define api-host-url "")

;; Base api for the Kyber API Gateway
(def base-api-url
  (str api-host-url "/api"))

;; Analytics Tracking
(def google-tracking-id
  (kpc-config "GOOGLE_TRACKING_ID"))

(def google-tracking-cross-domains
  (-> (kpc-config "GOOGLE_TRACKING_CROSS_DOMAINS") (split ",")))

;; Feature Flags
(def feature-flags
  (try
    (t/read (kpc-config "FEATURE_FLAGS"))
    (catch js/Error e
      (js/console.error "Error reading feature-flags " e))))

;; Stack Settings
(def stack-name
  (kpc-config "STACK_NAME"))
(def enable-unsubscribe
  (kpc-config "ENABLE_UNSUBSCRIBE"))

;; AWS SDK
(def aws-region
  (kpc-config "AWS_REGION"))
(def cognito-user-pool-id ;; Cognito User Pool ID
  (kpc-config "USER_POOL_ID"))
(def cognito-client-id ;; Cognito Client ID
  (kpc-config "USER_POOL_CLIENT_ID"))
(def user-pool-domain ;; Cognito User Pool Domain
  (kpc-config "USER_POOL_DOMAIN"))

;; OAuth
(def oauth-scope "profile email openid aws.cognito.signin.user.admin")

;; Social IDs
(def social-enabled
  (kpc-config "SOCIAL_ENABLED"))
(def google-id
  (kpc-config "GOOGLE_ID"))

;; Interval specs are checked for error reporting
(def spec-polling-interval 5000)

;; Polling time in ms for analytics service
(def analytics-polling-interval 5000)

;; Max number of retires while talking to the analytics service
(def max-analytics-retries 2)

;; Retry exponential back-off in ms
(def analytics-exponential-back-off 5000)

;; PDFTron
(def pdftron-api-key
  (kpc-config "PDFTRON_API_KEY"))

;; Time in seconds that constitutes "Moment is Active" when video is progressing
(def active-moment-threshold 0.5)

;; Time in ms that media will auto rewind before playback to regain context
(def playback-buffer-time 0)

(def html5-media-player-events
  [:abort
   :canplay
   :canplaythrough
   :durationchange
   :emptied
   :ended
   :error
   :loadeddata
   :loadedmetadata
   :loadstart
   :pause
   :play
   :playing
   :progress
   :ratechange
   :resize
   :seeked
   :seeking
   :stalled
   :suspend
   :timeupdate
   :volumechange
   :waiting])

;; Extra Option UUID
(def custom-answer-uuid "other-option-uuid")
(def rating-scale-custom-answer-uuid "other")

(defonce media-control-bar-height 40)

(defonce refresh-token-polling-interval
  (* 1000 5)) ;; 5 seconds

(defonce token-refresh-interval
  (* 1000 60 10)) ;; 10 minutes

(defonce main-activity-key
  :main-activity)

(def readiness-scale-spectrum
  ["#6C0102"
   "#9E2B27"
   "#CB534C"
   "#EB8379"
   "#FCBAB1"
   "#97D1FD"
   "#5CA9E6"
   "#2880CA"
   "#10589F"
   "#013374"])

;; Part of non-optimal workaround for redirect bug
;; https://github.com/Archemedx/kyber/issues/7156
(def initial-location (atom nil))
